/** AUTO-GENERATED from shared/taxonomy/care_taxonomy.json — do not edit by hand. */
/** policyCareClass / policyLicenseFamily joined from policy-library/care-type-license-map.json (Phase 5). */

export const TAXONOMY_VERSION = "2d520c6d9619" as const;

export type PolicyCareClass =
  | "license_primary"
  | "license_alias"
  | "service_tag"
  | "deferred_pack"
  | "invalid";

export type TaxonomyEntryStatus = "active" | "deprecated";

export const BUSINESS_TYPE_DEFINITIONS = [
  { key: "assisted_living", fullLabel: "Assisted Living Facility", registrationLabel: "Assisted Living", searchFilterLabel: "Assisted Living", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "license_primary" as PolicyCareClass | null, policyLicenseFamily: "assisted_living" },
  { key: "home_care", fullLabel: "Home Care", registrationLabel: "Home Care", searchFilterLabel: "Home Care Agency", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: "Plan 34 hybrid (2026-10-12): storage + card affinity stay on home_care; search picklist hides Home Care Agency (in_search_dropdown false). HHA inventory discovery of home_care peers uses BUSINESS_TYPE_SEARCH_PEERS only (not replaced_by). Registration remains off (in_registration false).", policyCareClass: "license_primary" as PolicyCareClass | null, policyLicenseFamily: "home_care" },
  { key: "group_home", fullLabel: "Group Home", registrationLabel: "Group Home", searchFilterLabel: "Community Residential Services", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "license_primary" as PolicyCareClass | null, policyLicenseFamily: "group_home" },
  { key: "memory_care", fullLabel: "Memory Care Facility", registrationLabel: "Memory Care (assisted living with dementia care)", searchFilterLabel: "Memory Care", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "license_alias" as PolicyCareClass | null, policyLicenseFamily: "assisted_living" },
  { key: "respite_care", fullLabel: "Respite Care", registrationLabel: null, searchFilterLabel: "Respite Care", inRegistration: false, requiresCapacity: true, status: "deprecated" as TaxonomyEntryStatus, replacedBy: null, sunset: "2026-12-01", notes: "service-like care type; search migrates to required services / community respite_care key", policyCareClass: "service_tag" as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "hospice", fullLabel: "Hospice Care", registrationLabel: "Hospice / End-of-Life", searchFilterLabel: "Hospice Provider", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "license_primary" as PolicyCareClass | null, policyLicenseFamily: "hospice" },
  { key: "nursing_home", fullLabel: "Nursing Home", registrationLabel: "Nursing Home", searchFilterLabel: "Nursing Home", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "deferred_pack" as PolicyCareClass | null, policyLicenseFamily: "nursing_home" },
  { key: "adult_day_care", fullLabel: "Adult Day Care", registrationLabel: "Adult Day Care", searchFilterLabel: "Adult Day Services", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "deferred_pack" as PolicyCareClass | null, policyLicenseFamily: "adult_day_care" },
  { key: "independent_living", fullLabel: "Independent Living Community", registrationLabel: "Independent Living", searchFilterLabel: "Independent Living", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "deferred_pack" as PolicyCareClass | null, policyLicenseFamily: "independent_living" },
  { key: "skilled_nursing", fullLabel: "Skilled Nursing Facility", registrationLabel: "Skilled Nursing", searchFilterLabel: "Skilled Nursing", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "deferred_pack" as PolicyCareClass | null, policyLicenseFamily: "nursing_home" },
  { key: "rehabilitation", fullLabel: "Rehabilitation Center", registrationLabel: "Rehabilitation", searchFilterLabel: "Rehabilitation", inRegistration: true, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "deferred_pack" as PolicyCareClass | null, policyLicenseFamily: "rehabilitation" },
  { key: "palliative_care", fullLabel: "Palliative Care", registrationLabel: null, searchFilterLabel: "Palliative Care", inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "service_tag" as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "home_health", fullLabel: "Home Health Agency", registrationLabel: null, searchFilterLabel: "Home Health Agency", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "license_alias" as PolicyCareClass | null, policyLicenseFamily: "home_care" },
  { key: "other", fullLabel: "Other", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: "invalid" as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "adult_family_home", fullLabel: "Adult Family Home", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "community_based_residential", fullLabel: "Community-Based Residential", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "residential_care_apartment", fullLabel: "Residential Care Apartment", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "residential_care", fullLabel: "Residential Care", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "apartment_living", fullLabel: "Apartment Living", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "senior_living", fullLabel: "Senior Living", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "elderly_care", fullLabel: "Elderly Care", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: true, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "medical_provider", fullLabel: "Medical Provider", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "healthcare_organization", fullLabel: "Healthcare Organization", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "healthcare_provider", fullLabel: "Healthcare Provider", registrationLabel: null, searchFilterLabel: null, inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "home_and_community_based_services", fullLabel: "Home & Community Based Services", registrationLabel: null, searchFilterLabel: "Home & Community Based Services", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "behavioral_health_provider", fullLabel: "Behavioral Health Provider", registrationLabel: null, searchFilterLabel: "Behavioral Health Provider", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "employment_services_provider", fullLabel: "Employment Services Provider", registrationLabel: null, searchFilterLabel: "Employment Services Provider", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "case_management_provider", fullLabel: "Care Coordination Provider", registrationLabel: null, searchFilterLabel: "Case Management / Care Coordination", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "foster_care_agency", fullLabel: "Foster Care Agency", registrationLabel: null, searchFilterLabel: "Foster Care Agency", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: "NPPES placement/coordination agency (taxonomy 253J00000X). Directory discovery type; does not itself license residential capacity. Distinct from adult_family_home (licensed residential setting).", policyCareClass: "deferred_pack" as PolicyCareClass | null, policyLicenseFamily: "foster_care" },
  { key: "community_based_practice", fullLabel: "Community-Based Practice", registrationLabel: null, searchFilterLabel: "Community-Based Practice", inRegistration: false, requiresCapacity: false, status: "active" as TaxonomyEntryStatus, replacedBy: null, sunset: null, notes: null, policyCareClass: null as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "chronic_disease_management", fullLabel: "Chronic Disease Management", registrationLabel: null, searchFilterLabel: "Chronic Disease Management", inRegistration: false, requiresCapacity: false, status: "deprecated" as TaxonomyEntryStatus, replacedBy: null, sunset: "2026-12-01", notes: "service-like care type; search migrates to required services (Chronic Disease Management)", policyCareClass: "service_tag" as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "wound_care", fullLabel: "Wound Care", registrationLabel: null, searchFilterLabel: "Wound Care", inRegistration: false, requiresCapacity: false, status: "deprecated" as TaxonomyEntryStatus, replacedBy: null, sunset: "2026-12-01", notes: "service-like care type; search migrates to required services (Wound Care)", policyCareClass: "service_tag" as PolicyCareClass | null, policyLicenseFamily: null },
  { key: "post_surgery_care", fullLabel: "Post-Surgery Care", registrationLabel: null, searchFilterLabel: "Post-Surgery Care", inRegistration: false, requiresCapacity: false, status: "deprecated" as TaxonomyEntryStatus, replacedBy: null, sunset: "2026-12-01", notes: "service-like care type; search migrates to required services (Post-Surgery Care)", policyCareClass: "service_tag" as PolicyCareClass | null, policyLicenseFamily: null },
] as const;

/** Alias → canonical business_type storage key (mirrors Python BUSINESS_TYPE_NORMALIZATION). */
export const BUSINESS_TYPE_NORMALIZATION: Record<string, string> = {
  "adult_day_care": "adult_day_care",
  "adult_day_services": "adult_day_care",
  "adult_family_home": "adult_family_home",
  "adult_foster_care": "adult_family_home",
  "adultdaycare": "adult_day_care",
  "adultdayservices": "adult_day_care",
  "adultfamilyhome": "adult_family_home",
  "adultfostercare": "adult_family_home",
  "adultfostercarehome": "adult_family_home",
  "armhs_provider": "behavioral_health_provider",
  "armhsprovider": "behavioral_health_provider",
  "assisted_living": "assisted_living",
  "assistedliving": "assisted_living",
  "behavioral health services": "behavioral_health_provider",
  "behavioral_health": "behavioral_health_provider",
  "behavioral_health_provider": "behavioral_health_provider",
  "behavioralhealth": "behavioral_health_provider",
  "behavioralhealthprovider": "behavioral_health_provider",
  "behavioralhealthservices": "behavioral_health_provider",
  "care_coordination": "case_management_provider",
  "care_coordination_provider": "case_management_provider",
  "care_management": "case_management_provider",
  "care_management_/_case_management": "case_management_provider",
  "care_management_provider": "case_management_provider",
  "carecoordination": "case_management_provider",
  "carecoordinationprovider": "case_management_provider",
  "caremanagement": "case_management_provider",
  "caremanagementprovider": "case_management_provider",
  "case_management": "case_management_provider",
  "case_management_/_care_coordination": "case_management_provider",
  "case_management_provider": "case_management_provider",
  "casemanagement": "case_management_provider",
  "casemanagementprovider": "case_management_provider",
  "community_based_practice": "community_based_practice",
  "community_based_practice_provider": "community_based_practice",
  "community_residential_services": "group_home",
  "community_support_provider": "home_and_community_based_services",
  "communitybasedpractice": "community_based_practice",
  "communityresidentialservices": "group_home",
  "communitysupportprovider": "home_and_community_based_services",
  "elderly_care": "elderly_care",
  "elderlycare": "elderly_care",
  "employment_services": "employment_services_provider",
  "employment_services_provider": "employment_services_provider",
  "employment_support_provider": "employment_services_provider",
  "employmentservices": "employment_services_provider",
  "employmentservicesprovider": "employment_services_provider",
  "foster care agency": "foster_care_agency",
  "foster_care_agency": "foster_care_agency",
  "fostercareagency": "foster_care_agency",
  "group_home": "group_home",
  "grouphome": "group_home",
  "hcbs": "home_and_community_based_services",
  "healthcare": "healthcare_provider",
  "healthcare_organization": "healthcare_organization",
  "healthcare_provider": "healthcare_provider",
  "healthcareorganization": "healthcare_organization",
  "healthcareprovider": "healthcare_provider",
  "home_care": "home_care",
  "home_care_agency": "home_care",
  "home_health": "home_health",
  "home_health_agency": "home_health",
  "home_health_care": "home_health",
  "homecare": "home_care",
  "homecareagency": "home_care",
  "homehealth": "home_health",
  "homehealthagency": "home_health",
  "hospice": "hospice",
  "hospice_provider": "hospice",
  "hospiceprovider": "hospice",
  "independent_living": "independent_living",
  "independentliving": "independent_living",
  "medical_provider": "medical_provider",
  "medicalprovider": "medical_provider",
  "memory_care": "memory_care",
  "memorycare": "memory_care",
  "mental_health": "other",
  "nursing_care": "skilled_nursing",
  "nursing_home": "nursing_home",
  "nursinghome": "nursing_home",
  "palliative_care": "palliative_care",
  "palliativecare": "palliative_care",
  "physical_therapy": "rehabilitation",
  "physicaltherapy": "rehabilitation",
  "rehabilitation": "rehabilitation",
  "residential_care": "residential_care",
  "residentialcare": "residential_care",
  "respite_care": "respite_care",
  "respitecare": "respite_care",
  "senior_living": "senior_living",
  "seniorliving": "senior_living",
  "skilled_nursing": "skilled_nursing",
  "skillednursing": "skilled_nursing",
  "support_coordination": "case_management_provider",
  "targeted_case_management": "case_management_provider",
  "vocational_services_provider": "employment_services_provider",
  "vocationalservicesprovider": "employment_services_provider",
};

export const ALL_BUSINESS_TYPES = [
  "assisted_living",
  "group_home",
  "memory_care",
  "hospice",
  "nursing_home",
  "adult_day_care",
  "independent_living",
  "skilled_nursing",
  "rehabilitation",
] as const;

export type RegistrationBusinessType = (typeof ALL_BUSINESS_TYPES)[number];

export const REGISTRATION_BUSINESS_TYPE_LABELS: Record<RegistrationBusinessType, string> = {
  "assisted_living": "Assisted Living",
  "group_home": "Group Home",
  "memory_care": "Memory Care (assisted living with dementia care)",
  "hospice": "Hospice / End-of-Life",
  "nursing_home": "Nursing Home",
  "adult_day_care": "Adult Day Care",
  "independent_living": "Independent Living",
  "skilled_nursing": "Skilled Nursing",
  "rehabilitation": "Rehabilitation",
};

export const BUSINESS_TYPE_REGISTRATION_OPTIONS = ALL_BUSINESS_TYPES.map((value) => ({
  value,
  label: REGISTRATION_BUSINESS_TYPE_LABELS[value],
}));

export const REGISTRATION_DEFAULTS = {
  "assisted_living": { services: ["24/7 Nursing Care", "Medication Management", "Personal Care Assistance", "Meal Preparation", "Housekeeping", "Social Activities", "Transportation"], specializations: ["memory_care"] },
  "group_home": { services: ["24/7 Nursing Care", "Medication Management", "Personal Care Assistance", "Meal Preparation", "Housekeeping"], specializations: [] },
  "memory_care": { services: ["24/7 Nursing Care", "Medication Management", "Memory Care", "Personal Care Assistance", "Meal Preparation", "Housekeeping"], specializations: ["memory_care"] },
} as const;

export const DEPRECATED_BUSINESS_TYPE_KEYS = new Set<string>([
  "chronic_disease_management",
  "post_surgery_care",
  "respite_care",
  "wound_care",
]);

/** Generated from shared/taxonomy/business_type_search_peers.json — do not edit. */
export const BUSINESS_TYPE_SEARCH_PEERS: Record<string, readonly string[]> = {
  "home_health": ["home_care"],
  "independent_living": ["assisted_living"],
  "memory_care": ["assisted_living", "nursing_home"],
  "respite_care": ["assisted_living", "group_home"],
};

export const PROVIDER_TYPES = [
  { value: "Assisted Living", label: "Assisted Living" },
  { value: "Home Health Agency", label: "Home Health Agency" },
  { value: "Community Residential Services", label: "Community Residential Services" },
  { value: "Adult Day Services", label: "Adult Day Services" },
  { value: "Hospice Provider", label: "Hospice Provider" },
  { value: "Home & Community Based Services", label: "Home & Community Based Services" },
  { value: "Case Management / Care Coordination", label: "Case Management / Care Coordination" },
  { value: "Behavioral Health Provider", label: "Behavioral Health Provider" },
];

export const BUSINESS_TYPES_REQUIRING_CAPACITY_AT_ORG_LOCATION_CREATE = new Set<string>([
  "assisted_living",
  "group_home",
  "memory_care",
  "respite_care",
  "hospice",
  "nursing_home",
  "adult_day_care",
  "independent_living",
  "skilled_nursing",
  "rehabilitation",
  "palliative_care",
  "adult_family_home",
  "community_based_residential",
  "residential_care_apartment",
  "residential_care",
  "apartment_living",
  "senior_living",
  "elderly_care",
]);

export const SERVICE_LIKE_SEARCH_BUSINESS_TYPES = new Set<string>([
  "chronic_disease_management",
  "post_surgery_care",
  "respite_care",
  "wound_care",
]);

export const SERVICE_OPTIONS = [
  {canonical: "Personal Care Assistance", label: "Assistance with Activities of Daily Living (ADLs)", patientNeed: true, aliases: ["Personal Care", "personal_care", "assistance_with_daily_activities", "adl_assistance", "Assistance with Activities of Daily Living"] },
  {canonical: "Medication Management", label: "Medication Management & Administration", patientNeed: true, aliases: ["medication_management", "med_management", "pharmacy_services"] },
  {canonical: "Meal Preparation", label: "Nutritious Meals & Snacks", patientNeed: true, aliases: ["meal_preparation", "nutritional_meals", "cooking"] },
  {canonical: "Transportation", label: "Transportation", patientNeed: true, aliases: ["Transportation Services (Medical Appointments & Community Outings)", "Transportation Assistance"] },
  {canonical: "Housekeeping", label: "Housekeeping & Laundry Services", patientNeed: true, aliases: ["housekeeping", "cleaning_services", "house_cleaning", "Housekeeping & Laundry", "Housekeeping & Laundry Services"] },
  {canonical: "Companionship", label: "Companionship", patientNeed: true, aliases: ["Companion Care", "companion_care"] },
  {canonical: "Respiratory Care", label: "Respiratory Care", patientNeed: true, aliases: ["Respiratory Therapy", "respiratory_therapy", "respiratory_care", "oxygen_therapy", "breathing_treatments"] },
  {canonical: "24/7 Nursing Care", label: "24-Hour Supervision & Assistance", patientNeed: true, aliases: ["24-Hour Supervision & Assistance", "24/7 Care", "24/7 Nursing Care", "24/7 Supervision"] },
  {canonical: "Skilled Nursing", label: "RN Oversight & Skilled Nursing Support", patientNeed: true, aliases: ["Nursing Care", "nursing_care", "RN Oversight & Skilled Nursing Support"] },
  {canonical: "Physical Therapy", label: "Physical Therapy", patientNeed: true, aliases: ["physical_therapy", "pt", "physiotherapy"] },
  {canonical: "Occupational Therapy", label: "Occupational Therapy", patientNeed: true, aliases: ["occupational_therapy", "ot", "adl_training"] },
  {canonical: "Speech Therapy", label: "Speech Therapy", patientNeed: true, aliases: ["speech_therapy", "st"] },
  {canonical: "Social Activities", label: "Recreational & Social Activities", patientNeed: true, aliases: ["social_activities", "recreational_activities", "Social Activities & Recreation", "Recreational & Social Activities"] },
  {canonical: "Care Coordination", label: "Care Coordination with Physicians & Specialists", patientNeed: true, aliases: ["care_coordination"] },
  {canonical: "Respite Care", label: "Respite Care / Short-Term Stay", patientNeed: true, aliases: ["respite_care", "Respite Care Services"] },
  {canonical: "Hospice Care", label: "Hospice/End-of-Life Support", patientNeed: true, aliases: ["hospice", "Hospice/End-of-Life Support", "end_of_life_care"] },
  {canonical: "Memory Care", label: "Memory Care", patientNeed: true, aliases: ["memory_care", "dementia_care", "alzheimers_care"] },
  {canonical: "Wound Care", label: "Wound Care", patientNeed: true, aliases: ["wound_care", "wound_management"] },
  {canonical: "Post-Surgery Care", label: "Post-Surgery Care", patientNeed: true, aliases: ["post_surgery_care", "post_operative_care", "Post-Surgical Recovery", "post_surgical_recovery"] },
  {canonical: "Home Health Care", label: "Home Health Care", patientNeed: true, aliases: ["Home Health Aide", "Home Health Aide Services", "Home Health", "home_health", "home_health_care", "home_health_aide"] },
  {canonical: "Medical Social Work", label: "Medical Social Work", patientNeed: true, aliases: ["Medical Social Services", "medical_social_work"] },
  {canonical: "Fall Prevention", label: "Fall Prevention", patientNeed: true, aliases: ["fall_prevention", "Fall Risk Reduction"] },
  {canonical: "Chronic Disease Management", label: "Chronic Disease Management", patientNeed: true, aliases: ["chronic_disease_management", "chronic_illness_care", "long_term_condition_management"] },
] as const;

export const ALL_AVAILABLE_SERVICES = SERVICE_OPTIONS.map((svc) => svc.label);
export const PREFERRED_SERVICES = ALL_AVAILABLE_SERVICES;
export const PATIENT_NEED_OPTIONS = SERVICE_OPTIONS.filter((svc) => svc.patientNeed).map((svc) => svc.label);
export const SERVICES_OPTIONS = [...ALL_AVAILABLE_SERVICES, "Other"];

export const SPECIALIZATION_OPTIONS = [
  {key: "developmental_disabilities", label: "Developmental Disabilities" },
  {key: "behavioral_health", label: "Behavioral Health" },
  {key: "brain_injury", label: "Brain Injury" },
  {key: "autism_spectrum", label: "Autism Spectrum" },
  {key: "physical_disabilities", label: "Physical Disabilities" },
  {key: "sensory_disabilities", label: "Sensory Disabilities" },
  {key: "cognitive_impairments", label: "Cognitive Impairments" },
  {key: "disability_nf_loc", label: "Disability (nursing-facility level of care)" },
  {key: "medically_complex_hospital_loc", label: "Medically complex / hospital level of care" },
  {key: "memory_care", label: "Memory Care" },
  {key: "aging_elderly", label: "Aging / Elderly" },
  {key: "children_pediatric", label: "Children / Pediatric" },
] as const;

export const SPECIALIZATIONS_OPTIONS = SPECIALIZATION_OPTIONS.map((s) => s.label);
export const SPECIALIZATION_OPTION_LABELS = SPECIALIZATION_OPTIONS.map((s) => s.label);

export const SPECIALIZATION_NAME_MAPPINGS: Record<string, string> = {
  "developmental_disabilities": "Developmental Disabilities",
  "behavioral_health": "Behavioral Health",
  "brain_injury": "Brain Injury",
  "autism_spectrum": "Autism Spectrum",
  "physical_disabilities": "Physical Disabilities",
  "sensory_disabilities": "Sensory Disabilities",
  "cognitive_impairments": "Cognitive Impairments",
  "disability_nf_loc": "Disability (nursing-facility level of care)",
  "medically_complex_hospital_loc": "Medically complex / hospital level of care",
  "aging_elderly": "Aging / Elderly",
  "children_pediatric": "Children / Pediatric",
  "memory_care": "Memory Care",
  "dementia_care": "Memory Care",
  "alzheimers_care": "Memory Care",
  "assisted_living": "Assisted Living",
  "independent_living": "Independent Living",
  "apartment_living": "Independent Living",
  "senior_living": "Independent Living",
  "residential_care": "Assisted Living",
  "residential_care_apartment": "Assisted Living",
  "community_based_residential": "Group Home",
  "nursing_home": "Nursing Home",
  "skilled_nursing": "Nursing Home",
  "home_health": "Home Health Agency",
  "home_care": "Home Care Agency",
  "healthcare_organization": "Healthcare Provider",
  "healthcare_provider": "Healthcare Provider",
  "medical_provider": "Healthcare Provider",
  "chronic_disease_management": "Chronic Disease Management",
  "wound_care": "Wound Care",
  "post_surgery_care": "Post-Surgery Care",
  "rehabilitation": "Rehabilitation",
  "respite_care": "Respite Care",
  "hospice": "Hospice / End-of-Life",
  "palliative_care": "Hospice / End-of-Life",
  "adult_day_care": "Adult Day Care",
  "elderly_care": "Adult Day Care",
  "group_home": "Group Home",
  "home_health_aide": "Home Health Aide",
};

export const REVERSE_SPECIALIZATION_MAPPINGS: Record<string, string> = {
  "Developmental Disabilities": "developmental_disabilities",
  "Behavioral Health": "behavioral_health",
  "Brain Injury": "brain_injury",
  "Autism Spectrum": "autism_spectrum",
  "Physical Disabilities": "physical_disabilities",
  "Sensory Disabilities": "sensory_disabilities",
  "Cognitive Impairments": "cognitive_impairments",
  "Disability (nursing-facility level of care)": "disability_nf_loc",
  "Medically complex / hospital level of care": "medically_complex_hospital_loc",
  "Aging / Elderly": "aging_elderly",
  "Children / Pediatric": "children_pediatric",
  "Memory Care": "memory_care",
  "Assisted Living": "assisted_living",
  "Independent Living": "independent_living",
  "Nursing Home": "nursing_home",
  "Home Care": "home_care",
  "Home Care Agency": "home_care",
  "Home Care Provider": "home_care",
  "Home Health Agency": "home_health",
  "Group Home": "group_home",
  "Respite Care": "respite_care",
  "Hospice / End-of-Life": "hospice",
  "Wound Care": "wound_care",
  "Post-Surgery Care": "post_surgery_care",
  "Rehabilitation": "rehabilitation",
  "Adult Day Care": "adult_day_care",
  "Healthcare Provider": "healthcare_provider",
  "Chronic Disease Management": "chronic_disease_management",
  "Alzheimer's Care": "memory_care",
  "Dementia Care": "memory_care",
  "Palliative Care": "palliative_care",
  "Skilled Nursing": "skilled_nursing",
  "Medical Provider": "healthcare_provider",
  "Healthcare Organization": "healthcare_provider",
  "Elderly Care": "adult_day_care",
  "Apartment Living": "independent_living",
  "Senior Living": "independent_living",
  "Residential Care": "assisted_living",
  "Residential Care Apartment": "assisted_living",
  "Community Based Residential": "group_home",
};

/** Search care-type labels → API business_type keys */
export const CARE_TYPE_DISPLAY_TO_BUSINESS_TYPE_KEY: Record<string, string> = {
  "Memory Care": "memory_care",
  "Dementia Care": "memory_care",
  "Chronic Disease Management": "chronic_disease_management",
  "Assisted Living": "assisted_living",
  "Home Care Agency": "home_care",
  "Home Health Agency": "home_health",
  "Community Residential Services": "group_home",
  "Adult Foster Care": "adult_family_home",
  "Adult Day Services": "adult_day_care",
  "Respite Care": "respite_care",
  "Hospice Provider": "hospice",
  "Wound Care": "wound_care",
  "Post-Surgery Care": "post_surgery_care",
  "Employment Services Provider": "employment_services_provider",
  "Home & Community Based Services": "home_and_community_based_services",
  "Case Management / Care Coordination": "case_management_provider",
  "Care Management / Case Management": "case_management_provider",
  "Community-Based Practice": "community_based_practice",
  "Behavioral Health Provider": "behavioral_health_provider",
  "Foster Care Agency": "foster_care_agency",
  "Independent Living": "independent_living",
  "Nursing Home": "nursing_home",
  "Home Care": "home_care",
  "Home Care Provider": "home_care",
  "Group Home": "group_home",
  "Hospice / End-of-Life": "hospice",
  "Rehabilitation": "rehabilitation",
  "Adult Day Care": "adult_day_care",
  "Healthcare Provider": "healthcare_provider",
  "Alzheimer's Care": "memory_care",
  "Palliative Care": "palliative_care",
  "Skilled Nursing": "skilled_nursing",
  "Medical Provider": "healthcare_provider",
  "Healthcare Organization": "healthcare_provider",
  "Elderly Care": "adult_day_care",
  "Apartment Living": "independent_living",
  "Senior Living": "independent_living",
  "Residential Care": "assisted_living",
  "Residential Care Apartment": "assisted_living",
  "Community Based Residential": "group_home",
};

export function mapCareTypeToBusinessTypeKey(displayLabel: string): string {
  if (!displayLabel || typeof displayLabel !== "string") return "";
  return CARE_TYPE_DISPLAY_TO_BUSINESS_TYPE_KEY[displayLabel] || displayLabel;
}

export const CAPABILITY_VARIANTS: Record<string, string[]> = {
  "Personal Care": ["Personal Care", "Personal Care Assistance", "personal_care", "assistance_with_daily_activities", "adl_assistance", "daily_care", "personal_assistance"],
  "Home Health Care": ["Home Health Care", "Home Health Aide Services", "Home Health Aide", "Home Health", "home_health", "home_health_care", "home_health_services", "home_nursing", "home_health_aide"],
  "Skilled Nursing": ["Skilled Nursing", "nursing_care", "Nursing Care", "medical_treatment", "RN Oversight & Skilled Nursing Support"],
  "Memory Care": ["Memory Care", "Alzheimer's Care", "Dementia Care", "memory_care", "dementia_care", "alzheimers_care", "cognitive_support"],
  "Assisted Living": ["Assisted Living", "assisted_living", "residential_care", "senior_living", "independent_living", "elderly_care"],
  "Residential Care": ["Residential Care", "Adult Family Home", "residential_care", "senior_living"],
  "Apartment Living": ["Apartment Living", "Community-Based Residential Facility"],
  "Healthcare Services": ["Healthcare Services", "healthcare_services"],
  "Medical Social Work": ["Medical Social Work", "Medical Social Services", "medical_social_work"],
  "Physical Therapy": ["Physical Therapy", "physical_therapy", "rehabilitation", "mobility_training", "pt", "physiotherapy"],
  "Occupational Therapy": ["Occupational Therapy", "occupational_therapy", "adl_training", "adaptive_equipment", "ot"],
  "Speech Therapy": ["Speech Therapy", "speech_therapy", "communication_training", "swallowing_therapy", "st"],
  "Medication Management": ["Medication Management", "medication_management", "pharmacy_services", "med_management"],
  "Wound Care": ["Wound Care", "wound_care", "wound_management"],
  "Diabetes Management": ["Diabetes Management", "diabetes_care", "nutrition_counseling", "medical_monitoring", "diabetes_support"],
  "Cardiac Care": ["Cardiac Care", "cardiac_care", "heart_monitoring", "cardiac_rehabilitation", "heart_care"],
  "Respiratory Care": ["Respiratory Care", "respiratory_care", "oxygen_therapy", "breathing_treatments", "lung_care", "Respiratory Therapy", "respiratory_therapy"],
  "Palliative Care": ["Palliative Care", "palliative_care", "hospice_services", "comfort_care", "end_of_life_care"],
  "General Care": ["General Care", "general_care"],
  "Housekeeping": ["Housekeeping", "housekeeping", "cleaning_services", "house_cleaning"],
  "Meal Preparation": ["Meal Preparation", "meal_preparation", "cooking", "food_preparation", "nutritional_meals"],
  "Social Activities": ["Social Activities", "social_activities", "recreational_activities", "social_programs", "entertainment"],
  "Chronic Disease Management": ["Chronic Disease Management", "chronic_disease_management", "chronic_illness_care", "long_term_condition_management"],
  "Post-Surgery Care": ["Post-Surgery Care", "post_surgery_care", "post_operative_care", "recovery_support", "surgical_follow_up"],
  "Healthcare Provider": ["Healthcare Provider", "healthcare_provider", "medical_provider", "healthcare_organization"],
  "Respite Care": ["Respite Care", "respite_care", "Respite Care / Short-Term Stay"],
  "Hospice Care": ["Hospice Care", "hospice", "Hospice/End-of-Life Support", "end_of_life_care"],
  "Care Coordination": ["Care Coordination", "care_coordination", "Care Coordination with Physicians & Specialists"],
  "Companionship": ["Companionship", "companionship", "Companion Care", "companion_care"],
  "Transportation": ["Transportation", "Transportation Services (Medical Appointments & Community Outings)"],
  "Fall Prevention": ["Fall Prevention", "fall_prevention", "Fall Risk Reduction"],
};

export const SERVICE_LABEL_TO_CANONICAL: Record<string, string> = {
  "Assistance with Activities of Daily Living (ADLs)": "Personal Care Assistance",
  "Personal Care": "Personal Care Assistance",
  "personal_care": "Personal Care Assistance",
  "assistance_with_daily_activities": "Personal Care Assistance",
  "adl_assistance": "Personal Care Assistance",
  "Assistance with Activities of Daily Living": "Personal Care Assistance",
  "Personal Care Assistance": "Personal Care Assistance",
  "Medication Management & Administration": "Medication Management",
  "medication_management": "Medication Management",
  "med_management": "Medication Management",
  "pharmacy_services": "Medication Management",
  "Medication Management": "Medication Management",
  "Nutritious Meals & Snacks": "Meal Preparation",
  "meal_preparation": "Meal Preparation",
  "nutritional_meals": "Meal Preparation",
  "cooking": "Meal Preparation",
  "Meal Preparation": "Meal Preparation",
  "Transportation": "Transportation",
  "Transportation Services (Medical Appointments & Community Outings)": "Transportation",
  "Transportation Assistance": "Transportation",
  "Housekeeping & Laundry Services": "Housekeeping",
  "housekeeping": "Housekeeping",
  "cleaning_services": "Housekeeping",
  "house_cleaning": "Housekeeping",
  "Housekeeping & Laundry": "Housekeeping",
  "Housekeeping": "Housekeeping",
  "Companionship": "Companionship",
  "Companion Care": "Companionship",
  "companion_care": "Companionship",
  "Respiratory Care": "Respiratory Care",
  "Respiratory Therapy": "Respiratory Care",
  "respiratory_therapy": "Respiratory Care",
  "respiratory_care": "Respiratory Care",
  "oxygen_therapy": "Respiratory Care",
  "breathing_treatments": "Respiratory Care",
  "24-Hour Supervision & Assistance": "24/7 Nursing Care",
  "24/7 Care": "24/7 Nursing Care",
  "24/7 Nursing Care": "24/7 Nursing Care",
  "24/7 Supervision": "24/7 Nursing Care",
  "RN Oversight & Skilled Nursing Support": "Skilled Nursing",
  "Nursing Care": "Skilled Nursing",
  "nursing_care": "Skilled Nursing",
  "Skilled Nursing": "Skilled Nursing",
  "Physical Therapy": "Physical Therapy",
  "physical_therapy": "Physical Therapy",
  "pt": "Physical Therapy",
  "physiotherapy": "Physical Therapy",
  "Occupational Therapy": "Occupational Therapy",
  "occupational_therapy": "Occupational Therapy",
  "ot": "Occupational Therapy",
  "adl_training": "Occupational Therapy",
  "Speech Therapy": "Speech Therapy",
  "speech_therapy": "Speech Therapy",
  "st": "Speech Therapy",
  "Recreational & Social Activities": "Social Activities",
  "social_activities": "Social Activities",
  "recreational_activities": "Social Activities",
  "Social Activities & Recreation": "Social Activities",
  "Social Activities": "Social Activities",
  "Care Coordination with Physicians & Specialists": "Care Coordination",
  "care_coordination": "Care Coordination",
  "Care Coordination": "Care Coordination",
  "Respite Care / Short-Term Stay": "Respite Care",
  "respite_care": "Respite Care",
  "Respite Care Services": "Respite Care",
  "Respite Care": "Respite Care",
  "Hospice/End-of-Life Support": "Hospice Care",
  "hospice": "Hospice Care",
  "end_of_life_care": "Hospice Care",
  "Hospice Care": "Hospice Care",
  "Memory Care": "Memory Care",
  "memory_care": "Memory Care",
  "dementia_care": "Memory Care",
  "alzheimers_care": "Memory Care",
  "Wound Care": "Wound Care",
  "wound_care": "Wound Care",
  "wound_management": "Wound Care",
  "Post-Surgery Care": "Post-Surgery Care",
  "post_surgery_care": "Post-Surgery Care",
  "post_operative_care": "Post-Surgery Care",
  "Post-Surgical Recovery": "Post-Surgery Care",
  "post_surgical_recovery": "Post-Surgery Care",
  "Home Health Care": "Home Health Care",
  "Home Health Aide": "Home Health Care",
  "Home Health Aide Services": "Home Health Care",
  "Home Health": "Home Health Care",
  "home_health": "Home Health Care",
  "home_health_care": "Home Health Care",
  "home_health_aide": "Home Health Care",
  "Medical Social Work": "Medical Social Work",
  "Medical Social Services": "Medical Social Work",
  "medical_social_work": "Medical Social Work",
  "Fall Prevention": "Fall Prevention",
  "fall_prevention": "Fall Prevention",
  "Fall Risk Reduction": "Fall Prevention",
  "Chronic Disease Management": "Chronic Disease Management",
  "chronic_disease_management": "Chronic Disease Management",
  "chronic_illness_care": "Chronic Disease Management",
  "long_term_condition_management": "Chronic Disease Management",
};

export const SERVICE_CANONICAL_TO_LABEL: Record<string, string> = {
  "Personal Care Assistance": "Assistance with Activities of Daily Living (ADLs)",
  "Medication Management": "Medication Management & Administration",
  "Meal Preparation": "Nutritious Meals & Snacks",
  "Transportation": "Transportation",
  "Housekeeping": "Housekeeping & Laundry Services",
  "Companionship": "Companionship",
  "Respiratory Care": "Respiratory Care",
  "24/7 Nursing Care": "24-Hour Supervision & Assistance",
  "Skilled Nursing": "RN Oversight & Skilled Nursing Support",
  "Physical Therapy": "Physical Therapy",
  "Occupational Therapy": "Occupational Therapy",
  "Speech Therapy": "Speech Therapy",
  "Social Activities": "Recreational & Social Activities",
  "Care Coordination": "Care Coordination with Physicians & Specialists",
  "Respite Care": "Respite Care / Short-Term Stay",
  "Hospice Care": "Hospice/End-of-Life Support",
  "Memory Care": "Memory Care",
  "Wound Care": "Wound Care",
  "Post-Surgery Care": "Post-Surgery Care",
  "Home Health Care": "Home Health Care",
  "Medical Social Work": "Medical Social Work",
  "Fall Prevention": "Fall Prevention",
  "Chronic Disease Management": "Chronic Disease Management",
};

export const COMMUNITY_SERVICE_DEFINITIONS = [
  { key: "community_residential_setting", label: "Community Residential Setting", aliases: ["Community Residential Setting"], group: "residential_care", caseSelectable: true, coverageMode: "facility_distance", regulated: true, inSearchFilters: false },
  { key: "residential_services_facility", label: "Residential Services Facility", aliases: ["Residential Services Facility"], group: "residential_care", caseSelectable: true, coverageMode: "facility_distance", regulated: true, inSearchFilters: true },
  { key: "mental_illness_residential_facility", label: "Residential Facility for Adults with Mental Illness", aliases: ["Mental Illness Residential Facility"], group: "residential_care", caseSelectable: true, coverageMode: "facility_distance", regulated: true, inSearchFilters: true },
  { key: "foster_care_or_supported_living_services", label: "Foster Care or Supported Living Services", aliases: ["Foster Care or Supported Living Services"], group: "residential_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "foster_care_services", label: "Foster Care Services", aliases: ["Foster Care Services"], group: "residential_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "supported_living_services", label: "Supported Living Services", aliases: ["Supported Living Services"], group: "residential_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "remote_overnight_supervision", label: "Remote Overnight Supervision", aliases: ["Remote Overnight Supervision"], group: "residential_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "cfss_provider_agency", label: "CFSS Provider Agency", aliases: ["CFSS provider agency"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: false },
  { key: "homemaker_services", label: "Homemaker Services", aliases: ["Homemaker services"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "homemaker_cleaning", label: "Homemaker \u2014 Cleaning", aliases: ["Homemaker - cleaning"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "homemaker_home_management", label: "Homemaker \u2014 Home Management", aliases: ["Homemaker - home management"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "homemaker_adl_assistance", label: "Homemaker \u2014 Assistance with ADLs", aliases: ["Homemaker - assistance with ADLs"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "night_supervision", label: "Night Supervision Services", aliases: ["Night supervision services"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "personal_support", label: "Personal Support", aliases: ["Personal support"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "home_delivered_meals", label: "Home-Delivered Meals", aliases: ["Home-delivered meals"], group: "daily_living_personal_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: false, inSearchFilters: true },
  { key: "crisis_respite", label: "Crisis Respite Services", aliases: ["Crisis respite services"], group: "caregiver_support_respite", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "positive_supports", label: "Positive Supports", aliases: ["Positive supports"], group: "behavioral_mental_health", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "armhs", label: "Adult Rehabilitative Mental Health Services", aliases: ["ARMHS"], group: "behavioral_mental_health", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "ihs_with_training", label: "Individualized Home Supports with Training", aliases: ["Individualized Home Supports with training"], group: "residential_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "ihs_with_family_training", label: "Individualized Home Supports with Family Training", aliases: ["Individualized Home Supports with family training"], group: "residential_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "ihs_without_training", label: "Individualized Home Supports without Training", aliases: ["Individualized Home Supports without training"], group: "residential_care", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "semi_independent_living_skills", label: "Semi-Independent Living Skills", aliases: ["Semi-independent living skills"], group: "disability_developmental_supports", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "integrated_community_supports", label: "Integrated Community Supports", aliases: ["Integrated Community Supports"], group: "community_social_supports", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "specialist_services", label: "Specialist Services", aliases: ["Specialist services"], group: "disability_developmental_supports", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "adult_companion_services", label: "Adult Companion Services", aliases: ["Adult companion services"], group: "community_social_supports", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "individual_community_living_support", label: "Individual Community Living Support", aliases: ["Individual community living support"], group: "community_social_supports", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "day_support_services", label: "Day Support Services", aliases: ["Day support services"], group: "community_social_supports", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "adult_day_services", label: "Adult Day Services", aliases: ["Adult day services"], group: "community_social_supports", caseSelectable: true, coverageMode: "facility_distance", regulated: true, inSearchFilters: true },
  { key: "family_adult_day_services", label: "Family Adult Day Services", aliases: ["Family adult day services"], group: "community_social_supports", caseSelectable: true, coverageMode: "facility_distance", regulated: true, inSearchFilters: true },
  { key: "cfss_consultation", label: "CFSS Consultation Services", aliases: ["CFSS consultation services"], group: "care_coordination_case_management", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "cfss_fms", label: "CFSS Financial Management Services", aliases: ["CFSS financial management services"], group: "care_coordination_case_management", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "waiver_case_management", label: "Waiver Case Management", aliases: ["Waiver case management"], group: "care_coordination_case_management", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "amh_targeted_case_management", label: "Adult Mental Health Targeted Case Management", aliases: ["AMH-TCM"], group: "care_coordination_case_management", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "cw_targeted_case_management", label: "Child Welfare Targeted Case Management", aliases: ["CW-TCM"], group: "care_coordination_case_management", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "rsc_targeted_case_management", label: "Relocation Service Coordination\u2014TCM", aliases: ["RSC-TCM"], group: "care_coordination_case_management", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "respite_care", label: "Respite Care Services", aliases: ["Respite care services"], group: "caregiver_support_respite", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "prevocational_services", label: "Prevocational Services", aliases: ["Prevocational", "Pre-vocational"], group: "employment_vocational_services", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "employment_exploration", label: "Employment Exploration Services", aliases: ["Employment exploration services"], group: "employment_vocational_services", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "employment_development", label: "Employment Development Services", aliases: ["Employment development services"], group: "employment_vocational_services", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "employment_support", label: "Employment Support Services", aliases: ["Employment support services"], group: "employment_vocational_services", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
  { key: "emergency_assistance_24hr", label: "24-Hour Emergency Assistance", aliases: ["24-hour emergency assistance"], group: "health_clinical_services", caseSelectable: true, coverageMode: "explicit_service_area", regulated: true, inSearchFilters: true },
] as const;
export type CommunityServiceKey = (typeof COMMUNITY_SERVICE_DEFINITIONS)[number]["key"];
export const COMMUNITY_SERVICE_KEYS = new Set<string>(COMMUNITY_SERVICE_DEFINITIONS.map((item) => item.key));
export const COMMUNITY_SERVICE_ALIAS_TO_KEY: Record<string, CommunityServiceKey> = Object.fromEntries(
  COMMUNITY_SERVICE_DEFINITIONS.flatMap((item) => [item.key, item.label, ...item.aliases].map((alias) => [alias.trim().toLocaleLowerCase(), item.key]))
) as Record<string, CommunityServiceKey>;

export interface CareServiceGroup {
  key: string;
  title: string;
}

export const CARE_SERVICE_GROUPS: readonly CareServiceGroup[] = [
  { key: "residential_care", title: "Residential Care" },
  { key: "daily_living_personal_care", title: "Daily Living & Personal Care" },
  { key: "behavioral_mental_health", title: "Behavioral & Mental Health" },
  { key: "disability_developmental_supports", title: "Disability & Developmental Supports" },
  { key: "community_social_supports", title: "Community & Social Supports" },
  { key: "care_coordination_case_management", title: "Care Coordination & Case Management" },
  { key: "caregiver_support_respite", title: "Caregiver Support & Respite" },
  { key: "employment_vocational_services", title: "Employment & Vocational Services" },
  { key: "health_clinical_services", title: "Health & Clinical Services" },
  { key: "memory_dementia_care", title: "Memory & Dementia Care" },
  { key: "accessibility_mobility", title: "Accessibility & Mobility" },
];

export const CARE_SERVICE_GROUP_TITLES: Record<string, string> = Object.fromEntries(
  CARE_SERVICE_GROUPS.map((group) => [group.key, group.title])
);

export const CARE_SERVICE_GROUP_ORDER: string[] = CARE_SERVICE_GROUPS.map(
  (group) => group.key
);

export function careServiceGroupRank(groupKey: string): number {
  const index = CARE_SERVICE_GROUP_ORDER.indexOf(groupKey);
  return index === -1 ? CARE_SERVICE_GROUP_ORDER.length : index;
}

export const GENERAL_SERVICE_GROUPINGS: Record<string, string> = {
  "Personal Care Assistance": "daily_living_personal_care",
  "Meal Preparation": "daily_living_personal_care",
  "Housekeeping": "daily_living_personal_care",
  "Medication Management": "health_clinical_services",
  "24/7 Nursing Care": "health_clinical_services",
  "Skilled Nursing": "health_clinical_services",
  "Home Health Care": "daily_living_personal_care",
  "Medical Social Work": "health_clinical_services",
  "Physical Therapy": "health_clinical_services",
  "Occupational Therapy": "health_clinical_services",
  "Speech Therapy": "health_clinical_services",
  "Wound Care": "health_clinical_services",
  "Hospice Care": "health_clinical_services",
  "Post-Surgery Care": "health_clinical_services",
  "Chronic Disease Management": "health_clinical_services",
  "Transportation": "community_social_supports",
  "Companionship": "community_social_supports",
  "Respiratory Care": "health_clinical_services",
  "Social Activities": "community_social_supports",
  "Care Coordination": "care_coordination_case_management",
  "Respite Care": "caregiver_support_respite",
  "Memory Care": "memory_dementia_care",
  "Fall Prevention": "health_clinical_services",
};

export const CONDITION_GROUPINGS: Record<string, string> = {
  "Physical Disabilities": "disability_developmental_supports",
  "Sensory Disabilities": "disability_developmental_supports",
  "Cognitive Impairments": "disability_developmental_supports",
  "Mobility Issues": "disability_developmental_supports",
  "Developmental Disabilities": "disability_developmental_supports",
  "Brain Injury": "disability_developmental_supports",
  "Autism Spectrum": "disability_developmental_supports",
  "Disability (nursing-facility level of care)": "disability_developmental_supports",
  "Medically complex / hospital level of care": "disability_developmental_supports",
  "Behavioral Health": "behavioral_mental_health",
  "Memory Care": "memory_dementia_care",
  "Dementia Support": "memory_dementia_care",
  "Alzheimer's Care": "memory_dementia_care",
};

export const ACCESSIBILITY_FEATURE_GROUP_KEY = "accessibility_mobility" as const;

export const CASE_GENERAL_SERVICE_LABELS = [
  "Physical Therapy",
  "Occupational Therapy",
  "Speech Therapy",
  "Nursing Care",
  "Home Health Care",
  "Medical Social Work",
  "Personal Care",
  "Companionship",
  "Respite Care",
  "Meal Preparation",
  "Transportation",
  "Medication Management",
  "Wound Care",
  "Respiratory Care",
] as const;

export const DISABILITY_CARE_CONDITION_OPTIONS = [
  "Physical Disabilities",
  "Sensory Disabilities",
  "Cognitive Impairments",
  "Mobility Issues",
  "Developmental Disabilities",
  "Behavioral Health",
  "Brain Injury",
  "Autism Spectrum",
  "Disability (nursing-facility level of care)",
  "Medically complex / hospital level of care",
  "Memory Care",
  "Dementia Support",
  "Alzheimer's Care",
] as const;

export const HANDICAP_ACCESSIBILITY_FEATURE_OPTIONS = [
  "Wheelchair Accessible",
  "Ramp Access",
  "Wide Doorways",
  "Accessible Parking",
  "Elevator Access",
  "Accessible Bathrooms",
  "Roll-in Shower",
  "Bathroom Hand Rails",
  "Grab Bars",
  "Accessible Toilet",
  "Lowered Countertops",
  "Accessible Light Switches",
  "Hoyer Lift (where applicable)",
  "Hospital Bed Available",
  "Stair Lift (home dependent)",
  "Assistive Technology",
  "Other",
] as const;

export const HANDICAP_ACCESSIBILITY_LABEL_ALIASES: Record<string, string> = {
  "Handicap Parking": "Accessible Parking",
};

export type ProviderTypeServiceAffinity = {
  typical_general?: readonly string[];
  compatible_general?: readonly string[];
  rare_general?: readonly string[];
  typical_community_keys?: readonly string[];
  compatible_community_keys?: readonly string[];
  rare_community_keys?: readonly string[];
};

export const PROVIDER_TYPE_SERVICE_AFFINITY: Readonly<Record<string, ProviderTypeServiceAffinity>> = {
  "home_care": {
    typical_general: ["Personal Care Assistance", "Companionship", "Housekeeping", "Medication Management", "Meal Preparation", "Transportation"] as const,
    rare_general: ["Skilled Nursing", "Physical Therapy", "Occupational Therapy", "Speech Therapy", "Wound Care", "Post-Surgery Care"] as const,
    rare_community_keys: ["day_support_services", "adult_day_services"] as const,
  },
  "home_health": {
    typical_general: ["Skilled Nursing", "Physical Therapy", "Occupational Therapy", "Speech Therapy", "Medical Social Work", "Home Health Care"] as const,
    compatible_general: ["Personal Care Assistance", "Companionship", "Post-Surgery Care", "Wound Care", "Medication Management"] as const,
    rare_general: ["Memory Care"] as const,
  },
  "assisted_living": {
    typical_general: ["24/7 Nursing Care", "Personal Care Assistance", "Medication Management", "Meal Preparation", "Housekeeping", "Social Activities", "Memory Care"] as const,
    rare_community_keys: ["day_support_services", "employment_support"] as const,
  },
  "group_home": {
    typical_general: ["Personal Care Assistance", "Medication Management"] as const,
    rare_general: ["Physical Therapy", "Occupational Therapy"] as const,
  },
  "adult_family_home": {
    typical_general: ["Personal Care Assistance", "Medication Management"] as const,
    rare_general: ["Physical Therapy", "Occupational Therapy"] as const,
  },
  "adult_day_care": {
    typical_general: ["Companionship", "Social Activities", "Personal Care Assistance"] as const,
    rare_general: ["24/7 Nursing Care"] as const,
  },
  "hospice": {
    typical_general: ["Skilled Nursing", "Hospice Care", "Care Coordination"] as const,
    rare_community_keys: ["adult_day_services", "employment_support"] as const,
  },
  "home_and_community_based_services": {
    typical_community_keys: ["day_support_services", "adult_companion_services", "respite_care"] as const,
  },
  "case_management_provider": {
    typical_community_keys: ["waiver_case_management", "amh_targeted_case_management", "cw_targeted_case_management", "rsc_targeted_case_management", "cfss_consultation", "cfss_fms"] as const,
  },
  "behavioral_health_provider": {
    rare_general: ["Memory Care"] as const,
    typical_community_keys: ["armhs", "positive_supports", "amh_targeted_case_management"] as const,
  },
};

export const TAXONOMY_STRICT_ENFORCEMENT_TARGET_DATE = "2026-12-01" as const;

export function businessTypeRequiresOrgLocationCapacity(businessTypeKey: string): boolean {
  return BUSINESS_TYPES_REQUIRING_CAPACITY_AT_ORG_LOCATION_CREATE.has(businessTypeKey);
}

export function isServiceLikeSearchBusinessType(databaseSlug: string): boolean {
  return SERVICE_LIKE_SEARCH_BUSINESS_TYPES.has(databaseSlug);
}
